import React from 'react';
import {
  Calendar, MapPin, Repeat, AlertTriangle, Phone, BarChart, CheckSquare,
  Bell, Cpu, Edit, FileText,
} from 'lucide-react';

const TYPE_META = {
  meeting:              { label: 'Reunião',                icon: Calendar,       color: 'bg-blue-100 text-blue-700' },
  site_visit:           { label: 'Visita',                 icon: MapPin,         color: 'bg-violet-100 text-violet-700' },
  follow_up:            { label: 'Follow-up',              icon: Repeat,         color: 'bg-orange-100 text-orange-700' },
  deadline:             { label: 'Deadline',               icon: AlertTriangle,  color: 'bg-red-100 text-red-700' },
  callback:             { label: 'Callback',               icon: Phone,          color: 'bg-cyan-100 text-cyan-700' },
  pipeline_review:      { label: 'Revisão de Pipeline',    icon: BarChart,       color: 'bg-indigo-100 text-indigo-700' },
  task:                 { label: 'Tarefa',                 icon: CheckSquare,    color: 'bg-slate-100 text-slate-700' },
  reminder:             { label: 'Lembrete',               icon: Bell,           color: 'bg-purple-100 text-purple-700' },
  agent_action:         { label: 'Ação de Agent',          icon: Cpu,            color: 'bg-teal-100 text-teal-700' },
  post_meeting_review:  { label: 'Pós-Reunião',            icon: Edit,           color: 'bg-amber-100 text-amber-700' },
  pre_meeting_briefing: { label: 'Briefing Pré-Reunião',   icon: FileText,       color: 'bg-sky-100 text-sky-700' },
};

export default function EventTypeBadge({ type, size = 'sm' }) {
  const meta = TYPE_META[type] || { label: type || '—', icon: Calendar, color: 'bg-slate-100 text-slate-600' };
  const Icon = meta.icon;
  const iconSize = size === 'sm' ? 11 : 13;
  const textClass = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-medium ${meta.color} ${textClass}`}>
      <Icon size={iconSize} /> {meta.label}
    </span>
  );
}

export const EVENT_TYPE_OPTIONS = Object.entries(TYPE_META).map(([value, m]) => ({ value, label: m.label }));
